/** Fixed traveler mobile bottom tab bar (excludes safe-area inset). */
export const TRAVELER_BOTTOM_NAV_HEIGHT = 56;

export const getTravelerBottomNavKey = (pathname = '', { signedIn = false } = {}) => {
  if (signedIn) {
    if (pathname === '/trips' || pathname.startsWith('/trips/')) return 'trips';
    if (pathname === '/memories' || pathname.startsWith('/memories/')) return 'memories';
    if (
      pathname === '/deals'
      || pathname.startsWith('/package')
      || pathname.startsWith('/p/')
    ) return 'packages';
    if (pathname === '/my-inquiries' || pathname.startsWith('/my-inquiries/')) return 'inquiries';
    if (pathname === '/my-bookings' || pathname.startsWith('/my-bookings/')) return 'bookings';
    return null;
  }
  if (pathname === '/trip-planner') return 'plan';
  if (
    pathname === '/deals'
    || pathname.startsWith('/package')
    || pathname.startsWith('/p/')
  ) return 'packages';
  if (pathname === '/destinations' || pathname.startsWith('/destinations/')) return 'destinations';
  if (pathname === '/guides' || pathname.startsWith('/guides/')) return 'guides';
  return null;
};

export const travelerSignedInBottomTabs = (packagesPath = '/deals?tab=packages') => ([
  { key: 'trips', to: '/trips', labelKey: 'nav.myTrips' },
  { key: 'memories', to: '/memories', labelKey: 'nav.memories' },
  { key: 'packages', to: packagesPath, labelKey: 'nav.packages' },
  { key: 'inquiries', to: '/my-inquiries', labelKey: 'nav.requests' },
  { key: 'bookings', to: '/my-bookings', labelKey: 'nav.myBookings' },
]);

export const travelerPublicBottomTabs = (packagesPath = '/deals?tab=packages') => ([
  { key: 'plan', to: '/trip-planner', labelKey: 'nav.planATrip' },
  { key: 'packages', to: packagesPath, labelKey: 'nav.packages' },
  { key: 'guides', to: '/guides', labelKey: 'nav.tabGuides' },
  { key: 'destinations', to: '/destinations', labelKey: 'nav.destinations' },
]);
